var map = {
	"./de@2x.png": "sGfM",
	"./en@2x.png": "jRcq",
	"./es@2x.png": "8ySj",
	"./fr@2x.png": "ilDL",
	"./hi@2x.png": "rgcX",
	"./id@2x.png": "+bG1",
	"./it@2x.png": "WR1f",
	"./ja@2x.png": "3qzn",
	"./jp@2x.png": "FrJc",
	"./ma@2x.png": "yKeA",
	"./ph@2x.png": "fsje",
	"./pt@2x.png": "duqb",
	"./tc@2x.png": "1Ies",
	"./th@2x.png": "anie",
	"./tw@2x.png": "PIz1",
	"./vi@2x.png": "uSB8",
	"./zh-TW@2x.png": "z4Zv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+JW0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flag ^\.\/.*@2x\.png$
// module id = +JW0
// module chunks = 0